import { useLanguage } from "@/context/LanguageContext";
import { CalendarDays, GitBranch, MapPin, TrendingUp } from "lucide-react";

const crmScreenshots = {
  dashboard: "https://customer-assets.emergentagent.com/job_quote-manager-65/artifacts/trlabyle_crm.png",
  stats: "https://customer-assets.emergentagent.com/job_quote-manager-65/artifacts/v7upz6il_crm1.png",
  map: "https://customer-assets.emergentagent.com/job_quote-manager-65/artifacts/ik4e4nmj_crm2.png",
  reports: "https://customer-assets.emergentagent.com/job_quote-manager-65/artifacts/86lqjpss_crm3.png",
  pipeline: "https://customer-assets.emergentagent.com/job_quote-manager-65/artifacts/n3tjrnxo_crm4.png",
  calendar: "https://customer-assets.emergentagent.com/job_quote-manager-65/artifacts/casexl0n_crm5.png",
};

export function CRMSection() {
  const { t } = useLanguage();

  const crmFeatures = [
    { icon: CalendarDays, key: "visits", color: "bg-blue-50 text-blue-600", screenshot: crmScreenshots.calendar },
    { icon: GitBranch, key: "pipeline", color: "bg-violet-50 text-violet-600", screenshot: crmScreenshots.pipeline },
    { icon: MapPin, key: "map", color: "bg-cyan-50 text-cyan-600", screenshot: crmScreenshots.map },
    { icon: TrendingUp, key: "reports", color: "bg-amber-50 text-amber-600", screenshot: crmScreenshots.reports },
  ];

  return (
    <section data-testid="crm-section" className="py-20 sm:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="text-sm uppercase tracking-[0.2em] font-bold text-[#22A7D1]">
            {t("crm.overline")}
          </span>
          <h2 className="mt-3 text-3xl sm:text-4xl tracking-tight font-bold text-slate-900">
            {t("crm.title")}
          </h2>
          <p className="mt-4 text-base sm:text-lg leading-relaxed text-slate-500">
            {t("crm.subtitle")}
          </p>
        </div>

        {/* Main CRM Dashboard Image */}
        <div className="rounded-2xl overflow-hidden border border-slate-200 shadow-xl shadow-slate-200/30 mb-12 bg-white" data-testid="crm-main-image">
          <img
            src="/images/edited_crm.png"
            alt={t("imageAlt.crmDashboard")}
            width="1200"
            height="700"
            className="w-full h-auto"
            loading="lazy"
            decoding="async"
          />
        </div>

        {/* CRM Feature Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          {crmFeatures.map((feature, i) => {
            const Icon = feature.icon;
            return (
              <div
                key={i}
                className="group rounded-2xl border border-slate-200 bg-white hover:border-slate-300 transition-all overflow-hidden"
                data-testid={`crm-feature-${feature.key}`}
              >
                <div className="p-5">
                  <div className={`w-10 h-10 rounded-xl flex items-center justify-center mb-3 ${feature.color}`}>
                    <Icon className="w-5 h-5" />
                  </div>
                  <h3 className="text-base font-semibold text-slate-900">{t(`crm.${feature.key}`)}</h3>
                  <p className="text-sm text-slate-500 mt-1">{t(`crm.${feature.key}Desc`)}</p>
                </div>
                <div className="px-3 pb-3">
                  <div className="rounded-lg overflow-hidden border border-slate-100">
                    <img
                      src={feature.screenshot}
                      alt={`EntegrePanel B2B CRM - ${t(`crm.${feature.key}`)}`}
                      width="300"
                      height="200"
                      className="w-full h-auto group-hover:scale-[1.02] transition-transform duration-500"
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
